export const title = "Report the problem here:";
export const link = "Submit report >";
export const uploadTitle =
  "Click UPLOAD to attach screenshots of your problem:";
export const uploadLink = "Upload";
